import { useEffect, useRef } from 'react';
import { useLocation, useNavigationType } from 'react-router-dom';

export const useScrollToTop = () => {
  const { pathname } = useLocation();
  const navigationType = useNavigationType();

  // Read the navigation type through a ref so it isn't an effect dependency:
  // the type flipping (e.g. POP -> REPLACE when a search param changes) must
  // not itself trigger a scroll. Only a pathname change should — search-param
  // updates like the meal-tab ?meal= toggle stay scroll-neutral.
  const navigationTypeRef = useRef(navigationType);
  navigationTypeRef.current = navigationType;

  useEffect(() => {
    // Scroll to top for new navigation (PUSH), preserve scroll for back/forward (POP)
    if (navigationTypeRef.current !== 'POP') {
      window.scrollTo(0, 0);
    }
  }, [pathname]);
};
